import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import './CSS/Header.css';
import { servicesData } from '../Helpers/ServicesHelper';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const servicesRef = useRef(null);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services', hasDropdown: true },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && servicesRef.current && !servicesRef.current.contains(event.target)) {
        setIsServicesDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleServicesClick = (e) => {
    e.preventDefault();
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
  };

  const handleServicesMouseEnter = () => {
    // Only enable hover on desktop
    if (window.innerWidth > 768) {
      setIsServicesDropdownOpen(true);
    }
  };

  const handleServicesMouseLeave = () => {
    // Only enable hover on desktop
    if (window.innerWidth > 768) {
      setIsServicesDropdownOpen(false);
    }
  };

  return (
    <header className='header'>
      <div className='container'>
        <div className='header-content'>
          {/* Logo */}
          <div className='logo'>
            <Link to='/'>
              <img src={logo} alt='fixINN Logo' className='logo-img' />
            </Link>
          </div>

          {/* Navigation */}
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            {/* Close Icon */}
            <button className='nav-close-icon' onClick={() => setIsMenuOpen(false)}>
              <svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M12 4L4 12M4 4L12 12' stroke='#000000' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </button>

            {/* Logo in drawer */}
            <div className='nav-drawer-logo'>
              <img src={logo} alt='fixINN Logo' className='nav-drawer-logo-img' />
            </div>

            <ul className='nav-list'>
              {navItems.map((item) => {
                if (item.hasDropdown) {
                  return (
                    <li
                      key={item.name}
                      className='nav-item services-nav-item'
                      ref={servicesRef}
                      onMouseEnter={handleServicesMouseEnter}
                      onMouseLeave={handleServicesMouseLeave}
                    >
                      <a href='#' className={`nav-link ${location.pathname.startsWith('/services') ? 'active' : ''}`} onClick={handleServicesClick}>
                        {item.name}
                        <span className={`dropdown-arrow ${isServicesDropdownOpen ? 'open' : ''}`}>
                          <img src={require('../assets/icons/chevron-down.png')} alt='arrow-down' />
                        </span>
                      </a>

                      {/* Services Dropdown */}
                      <div ref={dropdownRef} className={`services-dropdown ${isServicesDropdownOpen ? 'show' : ''}`}>
                        {Object.keys(servicesData).map((service, index) => (
                          <Link
                            key={servicesData[service].index}
                            to={servicesData[service].link}
                            className='dropdown-item'
                            onClick={() => {
                              setIsServicesDropdownOpen(false);
                              setIsMenuOpen(false);
                            }}
                          >
                            {servicesData[service].title}
                          </Link>
                        ))}
                      </div>
                    </li>
                  );
                }

                return (
                  <li key={item.name} className='nav-item'>
                    <Link
                      to={item.path}
                      className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* CTA Button */}
          <div className='header-cta'>
            <Link to='/contact' className='btn btn-primary' style={{ width: '179px', height: '60px' }}>
              Book a Service
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
